import { IMG } from "../data/site";
import { PageHero, Section, Overline, EnquiryForm } from "../components/site/bits";
import { Reveal, Stagger, StaggerItem } from "../components/site/motion";
import { Briefcase, GraduationCap, HeartHandshake, Gift, Users } from "lucide-react";

const WAYS = [
  { icon: Briefcase, t: "Employment opportunities", d: "Offer roles to residents ready and eager to work." },
  { icon: GraduationCap, t: "Work experience & apprenticeships", d: "Provide placements that build skills and confidence." },
  { icon: HeartHandshake, t: "Sponsorship", d: "Sponsor a programme, event or resident milestone." },
  { icon: Gift, t: "Donations", d: "Support our work with funding, goods or services." },
  { icon: Users, t: "Corporate volunteering", d: "Bring your team together for a meaningful cause." },
];

export default function Business() {
  return (
    <>
      <PageHero overline="Business Partnerships" lines={["Business with", "a bigger purpose."]} image={IMG.officeHigh5}
        intro="Employers and businesses play a vital role in helping refugees and vulnerable adults rebuild their futures. Partner with us to create real, lasting impact." />

      <Section>
        <Overline>How you can partner</Overline>
        <Stagger className="mt-10 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {WAYS.map((w) => (
            <StaggerItem key={w.t} className="rounded-2xl border border-brand-dark/10 bg-brand-surface p-8 transition-[transform,border-color] duration-300 hover:-translate-y-1 hover:border-brand-green/40">
              <w.icon className="h-8 w-8 text-brand-green" strokeWidth={1.5} />
              <h3 className="mt-5 font-serif text-xl text-brand-dark">{w.t}</h3>
              <p className="mt-3 text-sm text-brand-slate">{w.d}</p>
            </StaggerItem>
          ))}
        </Stagger>
      </Section>

      <Section className="bg-brand-surface/60">
        <div className="grid gap-16 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <Overline>Start a conversation</Overline>
            <Reveal><h2 className="mt-6 font-serif text-4xl tracking-tight text-brand-dark md:text-5xl">Let's build something meaningful.</h2></Reveal>
            <Reveal delay={0.1}><p className="mt-6 text-brand-slate">Tell us how your business would like to get involved and our partnerships team will be in touch to explore the opportunities.</p></Reveal>
          </div>
          <div className="lg:col-span-6 lg:col-start-7">
            <Reveal><div className="rounded-3xl border border-brand-dark/10 bg-brand-surface p-8 md:p-12">
              <EnquiryForm kind="business" testid="business-form" submitLabel="Partner with us" fields={[
                { name: "name", label: "Contact name", required: true, placeholder: "Full name" },
                { name: "organisation", label: "Company", required: true, placeholder: "Company name" },
                { name: "email", label: "Email", type: "email", required: true, placeholder: "you@company.com" },
                { name: "interest", label: "Partnership interest", type: "select", required: true, placeholder: "Select interest", options: WAYS.map((w) => w.t) },
                { name: "message", label: "Message", type: "textarea", placeholder: "Tell us how you'd like to help" },
              ]} />
            </div></Reveal>
          </div>
        </div>
      </Section>
    </>
  );
}
